<h2
  class="fdk-dialog-title"
  [id]="id">
  <ng-content></ng-content>
</h2>
